import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-gateway-setup',
  templateUrl: './payment-gateway-setup.component.html',
  styleUrls: ['./payment-gateway-setup.component.css']
})
export class PaymentGatewaySetupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
